import { UsuarioGrupo } from './usuario-grupo.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class UsuarioGrupoService {

    constructor(private http: Http) {
    }

    getUsuarioGrupos(): Observable<UsuarioGrupo[]> {
        return this.http.get(`${NTECH_API}/usuario-grupo`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/usuario-grupo/usuario-grupo.service.ts